import { payOut, receiptPayOut, dispenserPayOut } from '../services/device.service';
import balanceService from '../../../_common/services/balance.service';

const PAID = 'PAID';
const WITHDRAW = 'WITHDRAW';
const WITHDRAW_PIN = 'WITHDRAW_PIN';
const SET_WITHDRAW_AMOUNT = 'SET_WITHDRAW_AMOUNT';
const SET_PAYOUT = 'SET_PAID_AMOUNT';
const RECEIPT = 'RECEIPT';
const SET_RECEIPT_AMOUNT = 'SET_RECEIPT_AMOUNT';
const DISPENSER = 'DISPENSER';
const SET_DISPENSER_AMOUNT = 'SET_DISPENSER_AMOUNT';

const state = {
    withdrawAmount: null,    
    receiptAmount: null,    
    dispenserAmount: null,    
    payout: { }
};

const getters = {
    state: state => state 
}

const actions = {
    [WITHDRAW]: async ({ state, commit, dispatch }, { amount, phone }) => {
        commit(SET_WITHDRAW_AMOUNT, amount);
        await payOut(amount, phone);
    },
    [WITHDRAW_PIN]: async ({ commit }, { amount }) => {
        commit(SET_WITHDRAW_AMOUNT, amount);
        return await balanceService.withdraw(amount, null, {}); // branch = null, metadata = {}
    },
    [RECEIPT]: async ({ state, commit, dispatch }, { amount, phone }) => {
        commit(SET_RECEIPT_AMOUNT, amount);
        await receiptPayOut(amount, phone);
    },

    [DISPENSER]: async ({ state, commit, dispatch }, { amount }) => {
        commit(SET_DISPENSER_AMOUNT, amount);
        await dispenserPayOut(amount);
    },

    [PAID]: async ({ state, commit, dispatch }, payout) => {
        commit(SET_PAYOUT, payout);
    }
};

const mutations = {
    [SET_WITHDRAW_AMOUNT](state, amount) {
        state.withdrawAmount = amount;        
        state.payout = {}; 
    },
    [SET_RECEIPT_AMOUNT](state, amount) {
        state.receiptAmount = amount;        
        state.payout = {}; 
    },
    [SET_DISPENSER_AMOUNT](state, amount) {
        state.dispenserAmount = amount;        
        state.payout = {}; 
    },
    [SET_PAYOUT](state, payout) {
        state.payout = payout;        
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/withdraw.js